import { TokenIcons } from '../../../assets/icons';
import Card from '../../../components/Card';
import { Tokens } from '../../../config/constants';
import { formatAmountWithSuffix } from '../../../helpers';
import { UserTotalWithdrawals } from '../../../hooks/web3/pools/useUserTotalWithdrawals';

type TotalWithdrawsProps = {
    userTotalWithdraw: UserTotalWithdrawals;
};

const TotalWithdraws: React.FC<TotalWithdrawsProps> = ({ userTotalWithdraw }) => {
    return (
        <Card className='total-withdraws'>
            <div>
                <span className='label'>Pool</span>
                <span>
                    {TokenIcons[userTotalWithdraw.liquidityPool.lpToken]}
                    {userTotalWithdraw.liquidityPool.name.split(' ')[0]}
                </span>
            </div>
            <div>
                <span className='label'>{userTotalWithdraw.liquidityPool.lpToken}</span>
                <span>
                    {formatAmountWithSuffix(userTotalWithdraw.totalLpWithdrawn, {
                        minDecimals: 2,
                        minValue: 999_999.99,
                    })}{' '}
                </span>
            </div>
            <div>
                <span className='label'>USDC Value</span>
                <span>
                    {TokenIcons[Tokens.USDC]}{' '}
                    {formatAmountWithSuffix(userTotalWithdraw.totalAssetWithdrawn, {
                        minDecimals: 2,
                        currency: 'USD',
                        minValue: 999_999.99,
                    })}
                </span>
            </div>
        </Card>
    );
};

export default TotalWithdraws;
